var _circle, _rect, _circle2, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagBangDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F1F1FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 93,
    height: 93,
    rx: 46.5,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 46,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15697_254478",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 92,
    height: 92
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 101C80.4051 101 101 80.4051 101 55C101 29.5949 80.4051 9 55 9C29.5949 9 9 29.5949 9 55C9 80.4051 29.5949 101 55 101Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15697_254478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.705 6.29492H6.29297V103.707H103.705V6.29492Z",
    fill: "#006747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.587 84.7657C66.0256 84.7657 79.3517 71.4396 79.3517 55.001C79.3517 38.5624 66.0256 25.2363 49.587 25.2363C33.1484 25.2363 19.8223 38.5624 19.8223 55.001C19.8223 71.4396 33.1484 84.7657 49.587 84.7657Z",
    fill: "#DA291C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBangDestination);
export default __webpack_public_path__ + "static/media/flagBangDestination.ff20defe9f1ba86b3676de732e1bbf6b.svg";
export { ForwardRef as ReactComponent };